/* RESPONSIBLE TEAM: team-standalone */
import EditorConfig, {
  type PathConfigGenerationParams,
  type StepConfigGenerationParams,
} from 'embercom/objects/visual-builder/configuration/editor';
import { NewSalesforceCasePathConfig } from 'embercom/objects/visual-builder/configuration/path';

import type Step from 'embercom/models/operator/visual-builder/step';
import { StandaloneChatMessageConfiguration } from 'embercom/objects/visual-builder/configuration/step/chat-message';
import { StandaloneTicketFinStepConfig } from 'embercom/objects/visual-builder/configuration/step/fin';
import { stepTypes } from 'embercom/objects/visual-builder/configuration-list';
import { StandaloneAttributeCollectorConfiguration } from 'embercom/objects/visual-builder/configuration/step/attribute-collector';

export default class NewSalesforceCaseBotEditorConfig extends EditorConfig {
  generatePathConfig({ path, editorState }: PathConfigGenerationParams) {
    return new NewSalesforceCasePathConfig({
      path,
      editorState,
      supportsLocalAttributes: this.supportsLocalAttributes,
    });
  }

  generateStepConfig<S extends Step>({ step, pathConfig }: StepConfigGenerationParams<S>) {
    let stepConfigArgs = { step, pathConfig };

    switch (step.typeKey) {
      case stepTypes.attributeCollector:
        return new StandaloneAttributeCollectorConfiguration(stepConfigArgs);
      case stepTypes.chatMessage:
        return new StandaloneChatMessageConfiguration({
          ...stepConfigArgs,
          attributeService: this.attributeService,
        });
      case stepTypes.fin:
        return new StandaloneTicketFinStepConfig(stepConfigArgs);
      default:
        return super.generateStepConfig(stepConfigArgs);
    }
  }

  get supportsConversationChannelTargeting(): boolean {
    return false;
  }

  get supportsSideSheet(): boolean {
    return true;
  }
}
